import { render, staticRenderFns } from "./AdminOverview.vue?vue&type=template&id=118f8632"
import script from "./AdminOverview.vue?vue&type=script&lang=js"
export * from "./AdminOverview.vue?vue&type=script&lang=js"
import style0 from "./AdminOverview.vue?vue&type=style&index=0&id=118f8632&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports